import styled from 'styled-components'

export const ButtonBack = styled.button`
  align-self: center;
  width: 200px;
  background-color: var(--color-neutral-200);
  margin: 10px;
`
export const Button = styled.button`
  align-self: center;
  width: 200px;
  background-color: var(--color-neutral-200);
  margin: 10px;
`
export const WrapperButtons = styled.div`
  display: flex;
  justify-content: space-between;
`
